const getBooleanValue = (currentValue: boolean | string): boolean => {
  return typeof currentValue === 'string' ? currentValue === 'true' : currentValue
}

export default getBooleanValue
